import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-360f119a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "comment-template" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "comment-template__title" }, "Рекомендации от команды Curaprox", -1))
const _hoisted_3 = { class: "comment-template__content" }
const _hoisted_4 = { class: "comment-template__text" }
const _hoisted_5 = { class: "comment-template__buttons" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Вставить ")

import { onMounted, ref } from 'vue'


export default /*#__PURE__*/_defineComponent({
  emits: ['insert-comment'],
  setup(__props, { emit }) {



const getCuraproxTemplate = async (): Promise<void> => {
  templateCuraprox.value =
    '1. После профессиональной гигиены не принимать пищу и напитки в течение 2х часов.\n' +
    '2. Зубная щетка Curaprox 1560/3960/5460\n' +
    '3. Монопучковая щетка: CS 1006\n' +
    '4. Межзубные ершики: CPS Prime/CPS Perio\n' +
    '5. Зубная нить\n' +
    '6. Таблетки для индикации зубного налета: PCA 223.\n' +
    '7. Пенка Aliner foam: 2–3 раза в сутки\n' +
    '8. Кондиционер: Swiss Smile.\n' +
    '9. Зубные пасты:\n' +
    '     ·  Enzical Zero/950/1450\n' +
    '     ·  Be You / Black&White\n' +
    '     ·  Perio Plus\n' +
    '10. Ополаскиватель: Perio Plus 0,05/0,09/0,12\n' +
    '11. Жевательная резинка Curaprox серии "Black is White": 2 раза в день.'
}

const templateCuraprox = ref()

const handleTemplateInsert = (): void => {
  emit('insert-comment', templateCuraprox.value)
}

onMounted(() => {
  getCuraproxTemplate()
})

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("pre", _hoisted_4, _toDisplayString(templateCuraprox.value) + "\n      ", 1)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_el_button, {
        class: "comment-template__buttons-save",
        type: "primary",
        onClick: handleTemplateInsert
      }, {
        default: _withCtx(() => [
          _hoisted_6
        ]),
        _: 1
      })
    ])
  ]))
}
}

})